export function createArticlePermalink(ytid: string): string {
  return `/article/${ytid}`;
}
